import React, { useState } from 'react';
import { Button, Typography, Card, Row, Col, Divider, Space, Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import { RocketOutlined, TeamOutlined, EnvironmentOutlined, BulbOutlined, HomeOutlined } from '@ant-design/icons';
import Login from './login';
import PageTemplate from './PageTemplate';
import { useStateContext } from '../../contexts/ContextProvider';
const { Title, Paragraph } = Typography;


function HomePage() {
  const navigate = useNavigate();
  const { user } = useStateContext();
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const onDashboardClick = () => {
    if (user) {
      navigate('/dashboard');
    } else {
      setIsLoginModalOpen(true);
    }
  }

  const handleContactClick = () => {
    setIsContactModalOpen(true);
  }

  
  return (
    <PageTemplate>
      {/* Hero section */}
      <div className="bg-gradient-to-r from-blue-600 to-indigo-800 p-6 md:p-10 min-h-[300px] md:min-h-[400px] max-w-7xl mx-auto rounded-lg shadow-lg text-center flex flex-col justify-center items-center">
        <h1 className="text-white text-2xl md:text-4xl mb-4 md:mb-6">DANCO - Soluții Complete pentru Grădinițe, Școli și Primării</h1>
        <p className="text-white text-base md:text-lg mb-6 md:mb-8">
          Oferim produse de calitate superioară pentru instituții educaționale și administrație publică 
          în Republica Moldova, transformând spațiile în medii funcționale și sigure.
        </p>
        <Space direction="vertical" size="middle" className="w-full md:w-auto md:flex-row">
          <Button type="primary" size="large" 
            className="w-full md:w-auto bg-white text-blue-600 hover:bg-gray-100 border-none"
            onClick={() => navigate('/about')}>
            Descoperă Produsele Noastre
          </Button>
          <Button type="default" size="large" ghost
            className="w-full md:w-auto"
            onClick={handleContactClick}>
            Contactează-ne
          </Button>
        </Space>
      </div>

      {/* Products section */}
      <div className="bg-white mt-10 p-10 max-w-7xl mx-auto rounded-lg shadow-md">
        <Title level={2} className="text-center mb-12">Produsele Noastre</Title>
        
        <Row gutter={[24, 24]}>
          <Col xs={24} md={12} lg={8}>
            <Card 
              className="h-full hover:shadow-lg transition-all duration-300"
              cover={<div className="bg-green-50 p-6 flex justify-center"><RocketOutlined style={{ fontSize: 48, color: '#1890ff' }} /></div>}
            >
              <Title level={4}>Terenuri de Joacă</Title>
              <Paragraph>
                Spații de joacă moderne, sigure și durabile pentru grădinițe și școli, ce stimulează dezvoltarea copiilor.
              </Paragraph>
            </Card>
          </Col>
          <Col xs={24} md={12} lg={8}>
            <Card 
              className="h-full hover:shadow-lg transition-all duration-300"
              cover={<div className="bg-blue-50 p-6 flex justify-center"><EnvironmentOutlined style={{ fontSize: 48, color: '#52c41a' }} /></div>}
            >
              <Title level={4}>Mobilier Urban</Title>
              <Paragraph>
                Bănci, coșuri de gunoi și alte elemente de mobilier urban rezistente și estetice pentru spații publice.
              </Paragraph>
            </Card>
          </Col>
          <Col xs={24} md={12} lg={8}>
            <Card 
              className="h-full hover:shadow-lg transition-all duration-300"
              cover={<div className="bg-yellow-50 p-6 flex justify-center"><BulbOutlined style={{ fontSize: 48, color: '#faad14' }} /></div>}
            >
              <Title level={4}>Tehnică pentru Oficiu</Title>
              <Paragraph>
                Echipamente moderne și fiabile pentru birouri administrative și săli de clasă.
              </Paragraph>
            </Card>
          </Col>
          <Col xs={24} md={12} lg={12}>
            <Card 
              className="h-full hover:shadow-lg transition-all duration-300"
              cover={<div className="bg-purple-50 p-6 flex justify-center"><TeamOutlined style={{ fontSize: 48, color: '#722ed1' }} /></div>}
            >
              <Title level={4}>Mobilier din Inox</Title>
              <Paragraph>
                Soluții din inox de înaltă calitate pentru cantine școlare, bucătării și alte spații care necesită durabilitate.
              </Paragraph>
            </Card>
          </Col>
          <Col xs={24} md={12} lg={12}>
            <Card 
              className="h-full hover:shadow-lg transition-all duration-300"
              cover={<div className="bg-orange-50 p-6 flex justify-center"><HomeOutlined style={{ fontSize: 48, color: '#fa541c' }} /></div>}
            >
              <Title level={4}>Mobilier pentru Școli</Title>
              <Paragraph>
                Bănci, scaune, dulapuri și alte piese de mobilier ergonomice și durabile, adaptate pentru mediul educațional.
              </Paragraph>
            </Card>
          </Col>
        </Row>
      </div>

      {/* About section */}
      <div className="bg-gray-50 mt-10 p-10 max-w-7xl mx-auto rounded-lg shadow-md">
        <Row gutter={[48, 24]} align="middle">
          <Col xs={24} lg={12}>
            <Title level={2}>Despre Danco</Title>
            <Paragraph className="text-lg">
              Cu o experiență îndelungată pe piața din Republica Moldova, Danco s-a impus ca un furnizor de încredere 
              pentru instituțiile educaționale și administrațiile publice.
            </Paragraph>
            <Paragraph className="text-lg">
              Ne mândrim cu produse de calitate europeană, adaptate necesităților locale și realizate cu materiale durabile.
              Misiunea noastră este să contribuim la crearea unor spații educaționale și publice moderne și funcționale.
            </Paragraph>
            <Button type="primary" size="large" className="mt-4" onClick={() => navigate('/about')}>
              Află Mai Multe Despre Noi
            </Button>
          </Col>
          <Col xs={24} lg={12} className="flex justify-center">
            <div className="bg-blue-100 p-8 rounded-lg w-full max-w-md">
              <Title level={3} className="text-center mb-6">Solicită o Ofertă</Title>
              <Paragraph className="text-center mb-6">
                Suntem pregătiți să oferim soluții personalizate pentru nevoile instituției dumneavoastră.
                Contactați-ne pentru o ofertă adaptată cerințelor specifice.
              </Paragraph>
              <div className="text-center">
                <Button type="primary" size="large" onClick={handleContactClick}>Cere Ofertă</Button>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <Divider className="my-10" />

      <Modal
        title="Login"
        open={isLoginModalOpen}
        onCancel={() => setIsLoginModalOpen(false)}
        footer={null}
      >
        <Login onSuccess={() => setIsLoginModalOpen(false)} />
      </Modal>

      {/* Contact Modal */}
      <Modal
        title={null}
        open={isContactModalOpen}
        onCancel={() => setIsContactModalOpen(false)}
        footer={null}
        width={500}
        className="contact-modal"
        centered
        bodyStyle={{ padding: "0" }}
      >
        <div className="bg-gradient-to-br from-blue-50 to-indigo-100 p-8 text-center">
          <div className="flex justify-center mb-6">
            <img 
              src="/Logo_Danco.png" 
              alt="DANCO Logo" 
              className="h-16 w-auto"
            />
          </div>
          <Title level={3} className="mb-2 text-gray-800">Contactați-ne</Title>
          <Paragraph className="text-gray-600 mb-8">
            Suntem aici pentru a vă ajuta cu toate întrebările și solicitările dumneavoastră
          </Paragraph>
          
          <div className="space-y-4">
            {/* Phone Contact */}
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all duration-300">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="bg-green-100 p-3 rounded-full">
                    <span className="text-2xl">📞</span>
                  </div>
                  <div className="text-left">
                    <h4 className="font-semibold text-gray-800 mb-1">Telefon</h4>
                    <p className="text-gray-600">+373 78 888 001</p>
                  </div>
                </div>
                <Button 
                  type="primary" 
                  className="bg-green-500 hover:bg-green-600 border-green-500"
                  onClick={() => window.open('tel:+37378888001')}
                >
                  Sună Acum
                </Button>
              </div>
            </div>

            {/* Email Contact */}
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all duration-300">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="bg-blue-100 p-3 rounded-full">
                    <span className="text-2xl">📧</span>
                  </div>
                  <div className="text-left">
                    <h4 className="font-semibold text-gray-800 mb-1">Email</h4>
                    <p className="text-gray-600">info@danco.md</p>
                  </div>
                </div>
                <Button 
                  type="primary" 
                  onClick={() => window.open('mailto:info@danco.md')}
                >
                  Trimite Email
                </Button>
              </div>
            </div>

            {/* Address */}
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all duration-300">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="bg-purple-100 p-3 rounded-full">
                    <span className="text-2xl">📍</span>
                  </div>
                  <div className="text-left">
                    <h4 className="font-semibold text-gray-800 mb-1">Adresa</h4>
                    <p className="text-gray-600">Chișinău, str. Columna 102</p>
                  </div>
                </div>
                <Button 
                  type="default"
                  onClick={() => window.open('https://maps.google.com/?q=Chișinău, str. Columna 102', '_blank')}
                >
                  Vezi pe Hartă
                </Button>
              </div>
            </div>
          </div>

          {/* Program de lucru */}
          <div className="mt-8 p-4 bg-white/70 rounded-lg border border-white/50">
            <h4 className="font-semibold text-gray-800 mb-2">Program de lucru</h4>
            <div className="text-sm text-gray-600 space-y-1">
              <p>Luni - Vineri: 09:00 - 18:00</p>
              <p>Sâmbătă: 09:00 - 14:00</p>
              <p>Duminică: Închis</p>
            </div>
          </div>
        </div>
      </Modal>

      {/* Footer */}
      <div className="text-center mb-10">
        <Title level={3}>Transformăm Spațiile Educaționale și Publice</Title>
        <Paragraph className="text-lg mb-6">
          Cu Danco, aveți un partener de încredere pentru toate nevoile de mobilier și echipamente.
        </Paragraph>
        <Row justify="center" gutter={[16, 16]}>
          <Col>
            <Button type="primary" size="large" onClick={handleContactClick}>
              Contactează-ne
            </Button>
          </Col>
          <Col>
            <Button type="default" size="large" onClick={() => navigate('/about')}>
              Catalog Produse
            </Button>
          </Col>
        </Row>

      </div>
      
    </PageTemplate>
  );
}

export default HomePage;